"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdditionalScore = void 0;
const CardName_1 = require("../CardName");
const constants_1 = require("../constants");
function getAdditionalScore(player) {
    let score = 0;
    if (player.cardIsInEffect(CardName_1.CardName.ASIMOV))
        score += constants_1.ASIMOV_AWARD_BONUS;
    return score;
}
exports.getAdditionalScore = getAdditionalScore;
//# sourceMappingURL=IAward.js.map